import React from 'react';
import Header from "../../components/Header";
import styled from 'styled-components';
import Footer from "../../components/Footer";
import Mapa from "../../components/Mapa";
import { 
  Typography,
  IconButton,
} from '@material-ui/core';

import LocationOnIcon from '@material-ui/icons/LocationOn';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import AccessAlarmsIcon from '@material-ui/icons/AccessAlarms';

const Div = styled.div`
  a{
    backgroun-color: white;
  }
  #l4{
    background-color: #095EB2;
    color: white;
  }
  .bodyTxt{
    padding: 30px 0px 30px 0px;
    width: 100%;
    height: 400px;
    background-color: #F5F5F5;
    
    .conteudo{
      margin-left: 7%;
    }

    @media (max-width: 980px) {
     width: 100%;
    }
    @media (max-width: 610px) {
      width: 100%;
      .MuiTypography-body1{
        font-size: 13px !important;
      }
     }
     @media (max-width: 481px) {
      .MuiTypography-body1{
        font-size: 11px !important;
      }
     }
  }
`;
const Title = styled.div`
  border-bottom: 1px solid rgb(240, 240, 240);
  padding: 30px 30px 30px 0px;
  font-size: 40px;
  width: 86%;
  margin-left: 7%;
`;

function Contacto() {
  window.scrollTo(0, 0);
  return (
    <Div className="Contacto">
      <Header />
      <Title>Contactos</Title>
      
      <div className='bodyTxt'>
        <div className='conteudo' >
          <Typography variant="body1" gutterBottom style={{fontWeight: "bold"}}> 
              <IconButton>
                  <AccessAlarmsIcon />
              </IconButton>
              Aberto de Segunda a Sexta das 08H30 às 15H00
            </Typography>
            <Typography variant="body1" gutterBottom style={{fontWeight: "bold"}}> 
              <IconButton>
                  <LocationOnIcon />
              </IconButton>
              Avenida Imperial Santana, Quarteirão Maraca, Travessa B3, Distrito Urbano do Kilamba, Município de Belas, Luanda, Angola.
            </Typography>
            <Typography variant="body1" gutterBottom style={{fontWeight: "bold"}}> 
              <IconButton>
                  <EmailIcon />
              </IconButton>
              Email: suporte@inaarees.gov.ao
            </Typography>
            <Typography variant="body1" gutterBottom style={{fontWeight: "bold"}}> 
              <IconButton>
                  <PhoneIcon />
              </IconButton>
              Tel: (+244) 912656607
            </Typography>
            <Typography variant="body1" gutterBottom style={{fontWeight: "bold"}}> 
              <IconButton>
                  <PhoneIcon />
              </IconButton>
              Tel: (+244) 996881477
            </Typography>
          </div>
        </div>

        <Title>Localização</Title>

        <div class="mapa">
          <Mapa />
        </div>
      <Footer/>
    </Div>
  );
}

export default Contacto;
